module.exports = __webpack_public_path__ + "static/media/3DPPA24.f602ccc4.jpg";